module.exports = __webpack_public_path__ + "static/media/hero-image.7c4b86aa.jpg";